
<template>

  <!-- MPDT210068-2934-->
  <div class="text-center">
    <v-dialog v-model="dialog" width="450">
      <template v-slot:activator="{ on, attrs }">
        <v-row justify="center">
            <v-col cols="4">
                <v-btn
                  color="primary"
                  block
                  v-bind="attrs"
                  v-on="on"
                  data-cy="open-dialog-btn"
                >
                 Login to Proficloud-Billing
                </v-btn>
            </v-col>
        </v-row>
      </template>

      <v-card>
        <v-card-text>
          <p class="text-center text-h6 black--text pt-8">
            Login to Proficloud-Billing
          </p>
          <v-text-field v-model="username" label="Username"></v-text-field>
          <v-text-field
            v-model="password"
            label="Password"
            type="password"
          ></v-text-field>
          <v-btn
            block
            color="primary"
            class="mb-2 mt-6"
            :disabled="disabledLogin"
            @click="login()"
            >Login</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      dialog: false,
      username: "",
      password: "",
      errorText: ""
    };
  },
  computed: {
    disabledLogin() {
        return (this.username == undefined && this.password == undefined)
    }
  },
  methods: {

    async login() {
        let response;
        try {
            response = await this.$store.dispatch("loginBilling", {username: this.username, password: this.password});
            this.$emit("success", response);
            this.dialog = false
        } catch (error) {
            this.errorText = response
        }

            this.password = ""
    },
  },
};
</script>
